var App = App || {};

App.Utility = (function () {
    'use strict';

    function setCurrentDate() {
        var $date = $(".effectiveDate");

        $.each($date, function () {
            var $this = $(this),
                date = new Date(),
                dateFormatted = date.toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric",
                    year: "numeric"
                });

            $this.text("Effective Date: " + dateFormatted); // Outputs “March 12, 2026”
        });
    }

    return {
        setCurrentDate: setCurrentDate
    };
})(jQuery);

$(function () {
    App.Utility.setCurrentDate();
});